export default __webpack_public_path__ + "static/thumb-landscape-ecb8aa4a91418ba959377697451b2f30.jpg";